module.exports = __webpack_public_path__ + "img/icon-arrow-matrix-overview.a8ca0fc2.svg";